import { eLayoutType, RoutesService } from '@abp/ng.core';
import { APP_INITIALIZER } from '@angular/core';

export const ARTCAST_CACHES_ROUTE_PROVIDER = [
  { provide: APP_INITIALIZER, useFactory: configureRoutes, deps: [RoutesService], multi: true },
];


function configureRoutes(routes: RoutesService) {
  return () => {
    routes.add([
      {
        path: '/caches',
        iconClass: 'fas fa-sync',
        name: 'Caches',
        layout: eLayoutType.application,
        requiredPolicy: 'Artcast.Caches',
        order: 12
      },
    ]);
  };
}
